import { useContext } from "react";
import { SessionContext } from "../app/providers/SessionProvider";

export const useSession = () => useContext(SessionContext);
